import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import './LicenseInfoTable.css'
import { Modal } from "react-bootstrap";


const LicenseInfoTable = ({ agentLicenseInfo, onEditClick, onDeleteLicense }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editingLicense, setEditingLicense] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false); 
    const [selectedLicense, setSelectedLicense]  = useState()

      const handleShow = () => setShowConfirmation(true);
      const handleClose = () => setShowConfirmation(false);

    const columns = [
        { field: 'licenseNumber', header: 'License Number' },
        { field: 'state', header: 'State' },
        { field: 'expiryDate', header: 'Expiry Date' },
        { field: 'afftCompanyName', header: 'Company Name' },
        { field: 'officeAddress', header: 'Licensed State Office Address' },
        { field: 'status', header: 'Status' },
        {
            field: 'actions',
            header: 'Actions',
            render: (row) => (
                <div className="action-buttons">
                    <Button
                        onClick={() => onEditClick(row)}
                        variant="outlined"
                        aria-label="Edit"
                    >
                        <FaEdit />
                    </Button>
                    <Button
                        onClick={() => handleDelete(row.agentLicenseId)}
                        variant="outlined"
                        aria-label="delete"
                    >
                        <FaTrash />
                    </Button>
                </div>
            )
        }
    ];

    const handleDelete = () => {
        // Add confirmation before deletion

        console.log('selecteed lic ->' , selectedLicense);
        setShowConfirmation(false);
        onDeleteLicense(selectedLicense);
        
    };

    const getAddress = (license) => {
        var add = license?.city
        if(license?.state?.length > 0 ){
            if(license?.city?.length > 0){
               add = add +  ', ' + license.state;
            }else{
            add = add  + license.state;
            }
        } 
        if(license?.zip?.length > 0){
          add = add +    ', ' + license.zip
        }
        return add
    }
    return (

        <div className="pb30">
            {agentLicenseInfo && agentLicenseInfo?.length > 0 ? (
                agentLicenseInfo.map((license) => (


                    <div className="row col-xs-12 licenseDetRow " data-id="rtD6fUABSu" id="updateLicensertD6fUABSu">
                      


                        <div className="row update-license-actions">
                            <div className="col-10 license-error-message license-error-rtD6fUABSu">

                            </div>
                            <div className="col-2">
                               <Button style={{padding:0}}
                                    onClick={() => onEditClick(license)}
                                    variant="outlined"
                                >
                                    <FaEdit size={12} />
                                </Button>
                                <Button style={{padding:0}}
                                    onClick={() => {
                                        console.log('license ->',license);
                                        setSelectedLicense(license.licenseId);

                                        setShowConfirmation(true);
                                    }}
                                    variant="outlined"
                                >
                                    <FaTrash size={12} />
                                </Button>
                                </div>
                        </div>
                        <div className="row col-12">
                            <div className="col-6">
                                <div className="licenseSubHead">License Number : </div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle licenseNumberDisplay">{license?.licenseNumber}</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6 ">
                                <div className="licenseSubHead">State : </div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle">{license?.stateId}</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6 ">
                                <div className="licenseSubHead">Expiry Date : </div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle">{license?.expiryDate}</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <div className="licenseSubHead"> Licensed state office:</div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle">{license?.address1 + " " + license?.address2}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="licenseSubHead"> Address:</div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle">{getAddress(license)}</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <div className="licenseSubHead">Status : </div>
                            </div>
                            <div className="col-6">
                                <div className="licenseSubTitle ">{license.status === "LCNS_PEND" && "Pending" || '-'}</div>
                            </div>
                        </div>


                    </div>
                ))
            ) : (
                <tr>
                    <td colSpan={columns.length} className="text-center">
                        {/* No license information available */}
                    </td>
                </tr>
            )}

             <div className="confirmationModel">
            <Modal show={showConfirmation} onHide={handleClose}>
              <Modal.Header closeButton className="license-title">
                Delete license
              </Modal.Header>
              <Modal.Body>
                <p className="text-center">
                  Are you sure to delete the license?
                </p>
              </Modal.Body>
              <Modal.Footer className="justify-content-center">
                <button
                  onClick={handleDelete}
                  className="btn hubzu-btn-thm rounded"
                >
                  Yes
                </button>
                <button onClick={handleClose} className="license-delete-btn">
                  No
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
    );
};

export default LicenseInfoTable;
